<template>
    <div :class="classes">
        <slot></slot>
    </div>
</template>
<script>
    import theme from './grid.scss';

    export default {
        name: 'col',
        props: {
            theme: {
                type: Object,
                default() { return theme }
            },
            default: [Number, String], // 1-12
            // @TODO fix for safari
            fixHeight: Boolean,

            xs: [Number, String], // 1-12
            sm: [Number, String], // 1-12
            md: [Number, String], // 1-12
            lg: [Number, String], // 1-12
            xl: [Number, String], // 1-12

            pushXs: [Number, String], // 1-12
            pushSm: [Number, String], // 1-12
            pushMd: [Number, String], // 1-12
            pushLg: [Number, String], // 1-12
            pushXl: [Number, String], // 1-12

            pullXs: [Number, String], // 1-12
            pullSm: [Number, String], // 1-12
            pullMd: [Number, String], // 1-12
            pullLg: [Number, String], // 1-12
            pullXl: [Number, String], // 1-12

            alignSelf: String, // start, center, end
        },
        computed: {
            classes() {
                return {
                    [theme.col]: true, // auto width

                    [theme['col-' + this.default]]: this.default !== undefined,

                    [theme['col-' + this.xs]]: this.xs !== undefined,
                    [theme['col-sm-' + this.sm]]: this.sm !== undefined,
                    [theme['col-md-' + this.md]]: this.md !== undefined,
                    [theme['col-lg-' + this.lg]]: this.lg !== undefined,
                    [theme['col-xl-' + this.xl]]: this.xl !== undefined,

                    [theme['push-' + this.pushXs]]: this.pushXs !== undefined,
                    [theme['push-sm-' + this.pushSm]]: this.pushSm !== undefined,
                    [theme['push-md-' + this.pushMd]]: this.pushMd !== undefined,
                    [theme['push-lg-' + this.pushLg]]: this.pushLg !== undefined,
                    [theme['push-xl-' + this.pushXl]]: this.pushXl !== undefined,

                    [theme['pull-' + this.pullXs]]: this.pullXs !== undefined,
                    [theme['pull-sm-' + this.pullSm]]: this.pullSm !== undefined,
                    [theme['pull-md-' + this.pullMd]]: this.pullMd !== undefined,
                    [theme['pull-lg-' + this.pullLg]]: this.pullLg !== undefined,
                    [theme['pull-xl-' + this.pullXl]]: this.pullXl !== undefined,

                    [theme['align-self-' + this.alignSelf]]: this.alignSelf !== undefined,
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Col.vue?f00d5014